/* Open the product details before the browser follows its in-page link.
   Delegation also supports Shopify's section editor without duplicate handlers. */
(function () {
  'use strict';
  // Display labels only. Original option values remain in Shopify's product form.
  window.theme = window.theme || {};
  window.theme.pdVariantLabel = function (value) {
    if (!value) return value;
    var labels = window.theme.pdColorLabels || {};
    return String(value).split(' / ').map(function (part) {
      var key = part.trim().toLowerCase().replace(/\s+/g, '-');
      return Object.prototype.hasOwnProperty.call(labels, key) ? labels[key] : part;
    }).join(' / ');
  };

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('.pd-product-details-link');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    var details = document.getElementById(href.slice(1));
    if (details && details.tagName === 'DETAILS') details.open = true;
  });
}());
